export const ServiceRoutes = {
	Local: 'https://agilox.app.remberg.de/',
	LocalLive: 'https://agilox.app.remberg.de/',
	Test: 'https://agilox.app.remberg.de/',
	Beta: 'https://agilox.app.remberg.de/',
	Live: 'https://agilox.app.remberg.de/',
	Stage: 'https://agilox.app.remberg.de/',
} as const;
